import { Location } from '@angular/common';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

import { RouteNameEnum, RoutePathEnum } from '@connect-services/client/models/routes.model';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    private readonly isRedirecting = signal<boolean>(false);
    private readonly location = inject(Location);
    private readonly router = inject(Router);
    private readonly routingPanels: { isAlwaysLastUrlSegment: boolean; routeName: RouteNameEnum }[] = [
        { isAlwaysLastUrlSegment: true, routeName: RouteNameEnum.AI },
        { isAlwaysLastUrlSegment: true, routeName: RouteNameEnum.STATISTICS },
        { isAlwaysLastUrlSegment: true, routeName: RouteNameEnum.LAYERS },
        { isAlwaysLastUrlSegment: false, routeName: RouteNameEnum.FIELD_INTERVENTIONS },
        { isAlwaysLastUrlSegment: true, routeName: RouteNameEnum.SYNOPTIC },
        { isAlwaysLastUrlSegment: false, routeName: RouteNameEnum.SETTINGS },
    ];

    public async changeProjectRoute(projectId: string): Promise<void> {
        // force navigation to another project
        this.isRedirecting.set(true);
        const baseRoute = [RoutePathEnum.PROJECTS, projectId];
        const currentPanel = this.getCurrentUrlPanel();

        if (currentPanel) {
            baseRoute.push(currentPanel);
        }

        await this.router.navigate(baseRoute);
        this.isRedirecting.set(false);
    }

    public getCurrentUrlPanel(): string | undefined {
        const currentUrl = this.location.path();

        return this.routingPanels.find((panel) =>
            panel.isAlwaysLastUrlSegment
                ? currentUrl.endsWith(`/${panel.routeName}`)
                : currentUrl.includes(`/${panel.routeName}`),
        )?.routeName;
    }

    public async navigate(route: string[]): Promise<void> {
        if (this.isRedirecting()) {
            return;
        }

        this.isRedirecting.set(true);
        await this.router.navigate(route);
        this.isRedirecting.set(false);
    }
}
